import React from 'react';
import { useTranslation } from 'react-i18next';
import { openUpgradeFor } from './LocalCapHint';

const COLOR = { ok: '#6366f1', full: '#ef4444' };

/**
 * Plans v2 card 3.3, inside PlanLimitsPanel: one line per capped kind,
 * "3 / 1 boards: upgrade to Basic for unlimited". A line at or over its cap is
 * a button that opens the upgrade. Everything the user already has stays
 * readable, editable and exportable; the cap only stops new items.
 */
export default function LocalCapsSection({ rows, isDark, onClose }) {
  const { t } = useTranslation();
  if (!rows || rows.length === 0) return null;
  const muted = isDark ? '#a1a1aa' : '#6b7280';
  const strong = isDark ? '#fff' : '#111827';
  return (
    <div data-testid="local-caps-section" style={{ marginTop: 4, marginBottom: 6 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: strong }}>{t('plans.localCaps.title')}</div>
      {rows.map((row) => {
        const line = (
          <span style={{ color: row.full ? COLOR.full : muted, fontVariantNumeric: 'tabular-nums' }}>{row.text}</span>
        );
        return (
          <div key={row.kind} data-testid={`local-cap-${row.kind}`} style={{ marginTop: 4, fontSize: 10, lineHeight: 1.45 }}>
            {row.full ? (
              <button
                type="button"
                onClick={() => {
                  openUpgradeFor(row);
                  onClose?.();
                }}
                style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer', textAlign: 'left', fontSize: 10 }}
              >
                {line}
              </button>
            ) : (
              line
            )}
          </div>
        );
      })}
      <div style={{ marginTop: 6, fontSize: 10, color: muted, lineHeight: 1.45 }}>{t('plans.localCaps.hint')}</div>
    </div>
  );
}
